import React from "react";
import "./advantageStrip.style.sass";
import { Col, Icon, Row } from "rsuite";
import data from "../../data/advantageStrip/advantageStrip.json";

const AdvantageStrip = () => {
	return (
		<div className="strip">
			<Row>
				{data.map((item) => (
					<Col
						md={6}
						sm={12}
						xs={24}
						key={item.id}
					>
						<div className="advance">
							<Icon
								className="icon-custom"
								icon={item.icon}
							/>
							<p>{item.text}</p>
						</div>
					</Col>
				))}
			</Row>
		</div>
	);
};

export default AdvantageStrip;
